import { cn } from 'noddi-ui-common';
import { type MaybeDate, NoddiDateFormats, noddiFormatDate } from 'noddi-util';

type Props = {
  value: MaybeDate;
  className?: string;
};

/**
 * Stacked date + time for narrow list columns. Formats match the previous
 * single-line `meta.type: 'date-time'` cell (`NoddiDateFormats.DATE` / `TIME`).
 * Empty / invalid → `null`.
 */
export const NavioDateTimeCell = ({ value, className }: Props) => {
  const date = noddiFormatDate(value, NoddiDateFormats.DATE);
  const time = noddiFormatDate(value, NoddiDateFormats.TIME);
  if (!date) {
    return null;
  }

  return (
    <div
      className={cn('flex flex-col whitespace-nowrap', className)}
      title={noddiFormatDate(value, NoddiDateFormats.DATE_TIME)}
    >
      <span>{date}</span>
      <span className='text-xs text-muted-foreground'>{time}</span>
    </div>
  );
};
